import { Component } from 'preact';
import { framesStore, FrameItem } from '../store/frames';
import { effect, signal } from '@preact/signals';



export default class FrameDetailPage extends Component<{no: string}> {


    private virtualSlides = signal<{slides: FrameItem[], from: number, offset: number}>({ slides: [], from: 0, offset: 0});

    constructor(props: { no: string}) {
        super(props);
        framesStore.selectFrame(props.no);
    }

    private _onPopState = (e: PopStateEvent) => {
        if (!e.state.no) {
            return;
        }
        framesStore.selectFrame(e.state.no);
    };

    componentDidMount(): void {

        framesStore.load();

        //framesStore.selectFrame(this.props.no);


        (async () => {

            const swiperEl = document.querySelector('swiper-container');
            

            if (swiperEl) {

                const swiper = await import('swiper/element/bundle');
                swiper.register();

                const params = {
                    init: true,
                    // array with CSS styles
                    injectStyles: [      
                    `
                        .swiper {
                            --swiper-navigation-color: rgba(0,0,0, 0.47);
                        }
                        .invisible {
                            visibility: hidden;
                        }
                    `,
                    ],

                    slidesPerView: 'auto',
                    effect: 'cube',

                    on: {
                        slideChange: () => {
                            if (!swiperEl.swiper) {
                                return;
                            }
                            framesStore.selectedIndex.value = swiperEl.swiper.activeIndex;
                            const frame = framesStore.flatFramesList.value[swiperEl.swiper.activeIndex];
                            const url = '/brille/' + frame.no + location.search;
                            window.history.pushState({ no: frame.no }, 
                                [frame.name, 'Modell ' + frame.no, 'durchblick', 'Ihr fairer Optiker'].join(' - '), 
                                 url);
                        }
                    },

                    initialSlide: framesStore.selectedIndex.value,

                    virtual: { 
                        cache: true,
                        enabled: true,
                        addSlidesAfter: 0,
                        addSlidesBefore: 0,

                        slides: framesStore.flatFramesList.value,
                        renderExternal: (data: { slides: FrameItem[], from: number, offset: number }) => {
                            this.virtualSlides.value = data;
                            setTimeout(() => {
                                swiperEl.swiper.update();
                            }, 1);                     
                        },                    
                    },
                    
                };

                Object.assign(swiperEl, params);
                if (!swiperEl.swiper) {
                    swiperEl.initialize();
                }
                

                

                effect(() => {
                    if (swiperEl.swiper && swiperEl.swiper.virtual) {
                        swiperEl.swiper.virtual.slides = framesStore.flatFramesList.value;
                        swiperEl.swiper.update();
                    }
                });

                effect(() => {
                    if (swiperEl.swiper) {
                        swiperEl.swiper.slideTo(framesStore.selectedIndex.value, 0, false);                        
                    }
                });

            }
            })();

        window.addEventListener('popstate', this._onPopState);


        


        /**
         * 
         */
    }

    componentWillUnmount(): void {
        window.removeEventListener('popstate', this._onPopState);
    }

    componentWillReceiveProps(nextProps: Readonly<{ no: string; }>, nextContext: any): void {
        framesStore.selectFrame(nextProps.no);
    }

    reserve() {
        framesStore.addFrameToReservedList(framesStore.selectedFrame.value);
        framesStore.reservedDialogOpen.value = true;
    }

    render() {
        return <div id="frame-detail-page">
            <swiper-container class="mySwiper overflow-visible mt-1" init="false" effect="cube" grab-cursor="true" cube-effect-shadow="false"
                    cube-effect-slide-shadows="true" navigation-enabled="true" navigation-disabled-class="invisible" cube-effect-shadow-offset="20" cube-effect-shadow-scale="0.94">
                {this.virtualSlides.value.slides.map((frame, index) => {
                    return <swiper-slide data-swiper-slide-index={this.virtualSlides.value.from + index} key={frame.no} style={ {left: this.virtualSlides.value.offset + 'px' } }>
                        <div class="max-w-screen-xl mx-auto">
                            <div class="p-2 px-4 bg-white mb-10">
                                <h1 class="text-3xl font-bold text-neutral-600" dangerouslySetInnerHTML={{__html: frame.name}}></h1>
                                <h2 class="text-neutral-600">Modell: {frame.no}</h2>

                                <div class="px-2 mt-4 flex justify-center">
                                    <img class="w-full rounded-xl shadow-lg border border-neutral-100 md:w-10/12 min-h-[100px]" src={'image.php?id=' + frame.images[0]} />
                                </div>

                                <div class="details mt-4">
                                    {Object.keys(framesStore.attributesTitleMap.value)
                                        .filter(key => frame.attributes[key] && frame.attributes[key].length > 0)
                                        .map(key => <div class="flex my-1">
                                            <div class="w-[120px] inline-block">{framesStore.attributesTitleMap.value[key]}</div>
                                            <div class="gap-x-3 flex flex-wrap">
                                                {Array.isArray(frame.attributes[key]) 
                                                    ? 
                                                    frame.attributes[key].map(attr => (
                                                        <span class="bg-neutral-100 border border-neutral-400 text-neutral-700 rounded-lg px-3">{attr}</span>
                                                    ))
                                                    :
                                                    (<span class="bg-neutral-100 border border-neutral-400 text-neutral-700 rounded-lg px-3">{frame.attributes[key]}</span>)
                                                }
                                            </div>
                                        </div> )
                                    }
                                </div>


                                <div class="mt-4">

                                    <h3 class="text-2xl text-neutral-600">Fassung reservieren</h3>


                                    <p class="mt-2">
                                    Jede Fassung gibt es bei uns genau <strong>ein einziges mal</strong>.<br />
                                    Reservieren Sie jetzt diese und bis zu 2 weitere Fassungen
                                    mit einem Termin bei uns im Geschäft.
                                    </p>

                                    
                                    <div class="flex justify-end items-center gap-x-2">
                                        {framesStore.reservedFrameList.value.length > 2 
                                            ? <div class="text-neutral-600">Sie haben bereits 3 Fassungen ausgewählt.</div> : ''
                                        }

                                    <button onClick={() => this.reserve()} type="button"
                                    disabled={framesStore.reservedFrameList.value.length > 2}
                                        class="mt-4 text-durchblick-primary border-2 border-durchblick-primary hover:border-lime-400 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800
                                         disabled:border-gray-300 disabled:text-gray-300">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 400 400"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-opacity=".9" stroke-width="16" d="M236.581 255.636v72.29q30.301-42.714 39.253-55.553 8.952-12.84 45.166-57.735-10.486-24.642-26.348-44.016c-15.862-19.374-51.86-78.85-58.071-81.336-6.212-2.487-1.964 67.613-1.964 67.613s-16.561 1.859-41.852 1.859c-9.584 0-21.599-1.86-32.72-1.86-35.342 0-44.53-64.928-44.53-77.495s-1.12-5.49-7.555-5.49-34.655 69.855-27.933 110.957 38.071 70.766 100.563 70.766h36.409"/></svg>
                                                Fassung reservieren
                                    </button>
                                    </div>


                                </div>


                            </div>
                        </div>
                    </swiper-slide>
                })}
            </swiper-container>


{ !framesStore.knowHowToSwipeFlag.value ? 
  <div id="swipe-overlay" class="fixed inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center z-50" onClick={() => framesStore.knowHowToSwipe()}>
    <div class="text-white text-center px-6">
      <h2 class="text-xl md:text-2xl font-semibold mb-4">Wische nach links oder rechts um zur nächsten Brille zu gelangen</h2>

      <div class="relative w-24 h-[125px] mx-auto mb-6">

        <div class="absolute left-0 w-[200px] animate-swipe">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 606 378" width="606" height="378" preserveAspectRatio="xMidYMid meet" style="width: 100%; height: 100%; transform: translate3d(0px, 0px, 0px); content-visibility: visible;"><defs><clipPath id="__lottie_element_18"><rect width="606" height="378" x="0" y="0"></rect></clipPath></defs><g clip-path="url(#__lottie_element_18)"><g transform="matrix(0.2941800057888031,0,0,0.2941800057888031,124.00069427490234,216.00198364257812)" opacity="1" style="display: block;"><path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(123,81,27)" stroke-opacity="1" stroke-width="27" d=" M-223.3209991455078,-405.8429870605469 C-257.49200439453125,-395.1610107421875 -264.2900085449219,-371.364990234375 -255.3780059814453,-333.20098876953125 C-222.6490020751953,-251.54299926757812 -154.6649932861328,-93.47899627685547 -92.56500244140625,124.46299743652344 C-115.25399780273438,136.01699829101562 -215.67799377441406,-26.69499969482422 -284.72601318359375,38.16400146484375 C-320.3389892578125,82.2030029296875 -283.04998779296875,113.55999755859375 -274.10400390625,123.85600280761719 C-211.01600646972656,172.03399658203125 -120.33899688720703,309.3219909667969 -91.802001953125,321.8080139160156 C0,385.5929870605469 49.15299987792969,380.5090026855469 65.82499694824219,400.32501220703125 C77.49199676513672,422.82501220703125 85.73999786376953,446.2430114746094 85.73999786376953,446.2430114746094 C85.73999786376953,446.2430114746094 408.3810119628906,341.1159973144531 408.3810119628906,341.1159973144531 C408.3810119628906,341.1159973144531 392.56201171875,286.97698974609375 392.56201171875,286.97698974609375 C392.56201171875,286.97698974609375 430.5090026855469,145.76300048828125 390.5989990234375,41.5260009765625 C357.62799072265625,-44.06700134277344 289.18701171875,-208.8979949951172 289.18701171875,-208.8979949951172 C289.18701171875,-208.8979949951172 270.76300048828125,-252.54200744628906 223.69200134277344,-238.98300170898438 C156.7790069580078,-213.5590057373047 221.61000061035156,-152.11900329589844 194.18600463867188,-142.33099365234375 C175.8470001220703,-135.593994140625 168.6439971923828,-200.8470001220703 157.01100158691406,-223.22000122070312 C148.72900390625,-243.22000122070312 120.76300048828125,-260.1700134277344 91.50299835205078,-248.48899841308594 C63.83599853515625,-235.89700317382812 60.16899871826172,-214.8300018310547 61.52799987792969,-193.7100067138672 C64.40699768066406,-169.49099731445312 89.51100158691406,-125.74400329589844 75.01899719238281,-120.91799926757812 C62.71200180053711,-116.9489974975586 59.321998596191406,-142.3730010986328 35.7400016784668,-206.79400634765625 C26.69499969482422,-233.05099487304688 5.085000038146973,-248.72900390625 -23.398000717163086,-242.71200561523438 C-52.99700164794922,-236.39199829101562 -65.25399780273438,-206.3560028076172 -58.62699890136719,-181.35800170898438 C-46.676998138427734,-128.93899536132812 -13.135000228881836,-69.49199676513672 -35.07899856567383,-60.564998626708984 C-43.89899826049805,-58.59299850463867 -48.96699905395508,-72.31199645996094 -57.513999938964844,-94.11199951171875 C-93.47899627685547,-200.5540008544922 -147.86599731445312,-333.1239929199219 -163.72999572753906,-366.9020080566406 C-175.91000366210938,-382.4129943847656 -181.00900268554688,-411.3070068359375 -223.3209991455078,-405.8429870605469z M309.93,-52.71 C309.93,-52.71 354.2,171.76 206.09,336.11 C257.01,332.1 343.05,295.58 358.76,237.89 C394.6,79.09 309.93,-52.71 309.93,-52.71z"></path><path fill="rgb(224,172,105)" fill-opacity="1" d=" M-223.3209991455078,-405.8429870605469 C-257.49200439453125,-395.1610107421875 -264.2900085449219,-371.364990234375 -255.3780059814453,-333.20098876953125 C-222.6490020751953,-251.54299926757812 -154.6649932861328,-93.47899627685547 -92.56500244140625,124.46299743652344 C-115.25399780273438,136.01699829101562 -215.67799377441406,-26.69499969482422 -284.72601318359375,38.16400146484375 C-320.3389892578125,82.2030029296875 -283.04998779296875,113.55999755859375 -274.10400390625,123.85600280761719 C-211.01600646972656,172.03399658203125 -120.33899688720703,309.3219909667969 -91.802001953125,321.8080139160156 C0,385.5929870605469 49.15299987792969,380.5090026855469 65.82499694824219,400.32501220703125 C77.49199676513672,422.82501220703125 85.73999786376953,446.2430114746094 85.73999786376953,446.2430114746094 C85.73999786376953,446.2430114746094 408.3810119628906,341.1159973144531 408.3810119628906,341.1159973144531 C408.3810119628906,341.1159973144531 392.56201171875,286.97698974609375 392.56201171875,286.97698974609375 C392.56201171875,286.97698974609375 430.5090026855469,145.76300048828125 390.5989990234375,41.5260009765625 C357.62799072265625,-44.06700134277344 289.18701171875,-208.8979949951172 289.18701171875,-208.8979949951172 C289.18701171875,-208.8979949951172 270.76300048828125,-252.54200744628906 223.69200134277344,-238.98300170898438 C156.7790069580078,-213.5590057373047 221.61000061035156,-152.11900329589844 194.18600463867188,-142.33099365234375 C175.8470001220703,-135.593994140625 168.6439971923828,-200.8470001220703 157.01100158691406,-223.22000122070312 C148.72900390625,-243.22000122070312 120.76300048828125,-260.1700134277344 91.50299835205078,-248.48899841308594 C63.83599853515625,-235.89700317382812 60.16899871826172,-214.8300018310547 61.52799987792969,-193.7100067138672 C64.40699768066406,-169.49099731445312 89.51100158691406,-125.74400329589844 75.01899719238281,-120.91799926757812 C62.71200180053711,-116.9489974975586 59.321998596191406,-142.3730010986328 35.7400016784668,-206.79400634765625 C26.69499969482422,-233.05099487304688 5.085000038146973,-248.72900390625 -23.398000717163086,-242.71200561523438 C-52.99700164794922,-236.39199829101562 -65.25399780273438,-206.3560028076172 -58.62699890136719,-181.35800170898438 C-46.676998138427734,-128.93899536132812 -13.135000228881836,-69.49199676513672 -35.07899856567383,-60.564998626708984 C-43.89899826049805,-58.59299850463867 -48.96699905395508,-72.31199645996094 -57.513999938964844,-94.11199951171875 C-93.47899627685547,-200.5540008544922 -147.86599731445312,-333.1239929199219 -163.72999572753906,-366.9020080566406 C-175.91000366210938,-382.4129943847656 -181.00900268554688,-411.3070068359375 -223.3209991455078,-405.8429870605469z M309.93,-52.71 C309.93,-52.71 354.2,171.76 206.09,336.11 C257.01,332.1 343.05,295.58 358.76,237.89 C394.6,79.09 309.93,-52.71 309.93,-52.71z"></path><g opacity="1" transform="matrix(1,0,0,1,-5,-19)"><path fill="rgb(192,137,67)" fill-opacity="1" d=" M314.927001953125,-33.71099853515625 C314.927001953125,-33.71099853515625 359.1960144042969,190.7550048828125 211.09300231933594,355.1130065917969 C262.0069885253906,351.10101318359375 348.05499267578125,314.5769958496094 363.76300048828125,256.8869934082031 C399.60101318359375,98.08799743652344 314.927001953125,-33.71099853515625 314.927001953125,-33.71099853515625z"></path><path stroke-linecap="butt" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(123,81,27)" stroke-opacity="1" stroke-width="0" d=" M314.927001953125,-33.71099853515625 C314.927001953125,-33.71099853515625 359.1960144042969,190.7550048828125 211.09300231933594,355.1130065917969 C262.0069885253906,351.10101318359375 348.05499267578125,314.5769958496094 363.76300048828125,256.8869934082031 C399.60101318359375,98.08799743652344 314.927001953125,-33.71099853515625 314.927001953125,-33.71099853515625z"></path></g></g><g transform="matrix(1.0675524473190308,0.2602214813232422,-0.23682118952274323,0.9715532660484314,260.75823974609375,143.95010375976562)" opacity="1" style="display: block;"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(166,166,166)" stroke-opacity="1" stroke-width="6" d=" M-44.5,-99 C-33.06100082397461,-103.48600006103516 -21.368999481201172,-107.46099853515625 -9.5600004196167,-110.9800033569336"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,20)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(166,166,166)" stroke-opacity="1" stroke-width="6" d=" M19.465999603271484,-109.61900329589844 C30.06100082397461,-112.93800354003906 40.71900177001953,-115.81400299072266 51.35200119018555,-118.29900360107422"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,72)"><path stroke-linecap="round" stroke-linejoin="miter" fill-opacity="0" stroke-miterlimit="4" stroke="rgb(166,166,166)" stroke-opacity="1" stroke-width="6" d=" M-38.5,-90 C-27.405000686645508,-95.27100372314453 -16.16900062561035,-99.9749984741211 -4.896999835968018,-104.16899871826172"></path></g></g></g></svg>
        </div>
      </div>

      <button
        class="bg-white text-black font-medium px-6 py-2 rounded-full shadow-md hover:bg-gray-200 transition">
        Verstanden
      </button>
    </div>
  </div>

  : ''}


            

        </div>
    }
}

